module.exports = __webpack_public_path__ + "img/gry_10.04fd1274.png";